import React from 'react';
import DynamicForm from './tasks/DynamicForm';
import Task2UserStories from './tasks/Task2UserStories';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import MenuIcon from '@mui/icons-material/Menu';

const Content = ({ currentPage, selectedNode, selectedChild,dropValue,toggleLeftbar,isLeftbarVisible  }) => {
  return (
    <div className="">

<div className={`sticky-top fs-5 p-2 p-lg-3 ps-lg-4 text-center text-black fw-normal font-secondary flex-center justify-content-between ${isLeftbarVisible ? 'bg-theme-primary-verylight' : 'bg-white shadow'}`}>
            <div>
              <a className='me-2 hamburger flex-center' >
                {isLeftbarVisible ? 
                <div onClick={toggleLeftbar}><MenuOpenIcon /></div> 
                : 
                <div onClick={toggleLeftbar} className='flex-center'><MenuIcon /> <div className='ms-2'>Menu</div></div>}
              </a>
            </div>
            {!isLeftbarVisible ? <div>
              <img className='ms-2' src="/img/splash.png" width="70"/><span class="ms-2 fw-bold font-primary fs-5 pt-2 d-inline-block ">Double Diamond Design Process</span>
            </div> : ''}            

            {/* <div className={'d-none d-xl-block'}>{dropValue} </div>  */}
            {isLeftbarVisible ? 
            <div className='d-flex'>
                <div className='me-2'>
                    {selectedNode?'Phase ':''}{Math.floor(currentPage / 100) > 0 && <>{Math.floor(currentPage / 100)}</>}
                    {selectedNode?': ':''}
                    {selectedNode}
                  </div>
                <div>( {(Math.floor((currentPage % 100) / 10)) > 0 && <>Step {(Math.floor((currentPage % 100) / 10))}{(currentPage % 10) > 0 && '.'+currentPage % 10 }</>} )
                      {/* {selectedChild && selectedChild.length > 50 ? selectedChild.substring(0, 50) + '...' : selectedChild} */}
                </div>              
            </div>
            :<div style={{width:'105px'}}></div>}
          </div> 
          {!isLeftbarVisible ? 
          <div className='text-cetner py-2 bg-theme-accent text-white'>
          <div className='flex-center justify-content-center container-xl' style={{fontSize:'16px'}}>
                <div className='me-2  '>
                    {selectedNode?'Phase ':''}{Math.floor(currentPage / 100) > 0 && <>{Math.floor(currentPage / 100)}</>}
                    {selectedNode?': ':''}
                    <span className='fw-bold'>{selectedNode}</span>
                  </div>
                <div>
                  ({(Math.floor((currentPage % 100) / 10)) > 0 && <>Step {(Math.floor((currentPage % 100) / 10))}{(currentPage % 10) > 0 && '.'+currentPage % 10 }</>}
                  )
                      {/* {selectedChild && selectedChild.length > 50 ? selectedChild.substring(0, 50) + '...' : selectedChild} */}
                </div>              
            </div>
            </div> : ''}
          
               
         {/*  {`page_${Math.floor(currentPage / 10)}_${currentPage % 10}.html`}-- --{currentPage} */}
         {/* {currentPage}-- */}
       
      <div className='container-xl px-2 px-lg-3 pb-2 pt-1'>

          
          {/* {currentPage === 0 && <><h2 className='text-center text-black-8 my-3'>Double Diamond Design Process</h2></>} */}
          
          {currentPage !== 0 && 
          <>
          <div className='h4 font-secondary py-3 text-center'><span className='fw-normal'>
             </span>{selectedChild ? <>{selectedChild}</> : `${selectedNode} - Introduction `}
            </div>
          </>}
          
          {Math.floor(currentPage / 10) > 0 && 
          <div className='text-cetner p-2'>
            <img className='d-block m-auto img-fluid' src={`/pages/page_${Math.floor(currentPage / 100)}_${Math.floor((currentPage % 100) / 10)}${(currentPage % 10)? '_'+currentPage % 10 :''}.png`} />
          </div>        
          }
          
          
          {currentPage === 0 && 
          <>
          <div className='h4 font-secondary py-3 text-center'>Introduction</div>
          <div className='text-center'><img  className='img-fluid' src='/img/sample1.png'/></div>
          <br/><br/>          
          <div className='text-center'><a className='mt-4 d-inline-block p-4 px-4 rounded mb-2 bg-theme-pink text-white text-white fs-4' target='_blank' href="/task1">Fill Project Inception Form</a></div>          
          </>
          
          
          }
          {currentPage === 10 && 
          <>
          <div className='text-center'>
          <div className='h4 font-secondary pb-2 d-inline-block my-3 text-center border-bottom border-4 border-theme-pink'>Project Kickoff Questionnaire ({dropValue})</div>
          </div>
          <DynamicForm/>
          </>          
          }
          {currentPage === 113 && 
          <>
          <div className='text-center'>
          {/* <div className='h4 font-secondary pb-2 d-inline-block my-3 text-center border-bottom border-4 border-theme-pink'>Add User Story */}
          <div className='font-secondary d-inline-block my-3 text-center h6 fw-normal bg-theme-yellow-7 p-2'><b>Add User Story Url</b> : https//doublediamond.ayatacommerce.com/add-userstory?UYUNM340
          <a className='fs-5 ms-3' href='/add-userstory' target='_blank'>(Link)</a>
          </div>
          </div>
          <Task2UserStories/>
          </>          
          }          
          {currentPage === 510 && 
          <>
          <div className='text-center'>
          <div className='font-secondary d-inline-block my-3 text-center h6 fw-normal border border-warning p-2'><b>Case study template Link:</b> : 
          <a className='fs-5 ms-3 text-primary' href='https://docs.google.com/presentation/d/1oV6hzgVdo7aj__2bv0GvLDMmfoPluXbszbwT-h8CzjY/edit?usp=sharing' target='_blank'>https://docs.google.com/presentation..</a>
          </div>
          </div> 
          </>          
          }          
          {currentPage === 520 && 
          <>
          <div className='text-center'>
          <div className='font-secondary d-inline-block my-3 text-center h6 fw-normal border border-warning p-2'><b>User Story Template Link:</b> : 
          <a className='fs-5 ms-3 text-primary' href='https://docs.google.com/presentation/d/1ToE1I5gcoEjF99WrGYiTldMczfHaAKft-9Q0jKKevcc/edit?usp=sharing' target='_blank'>https://docs.google.com/presentation..</a>
          </div>
          </div> 
          </>          
          }
          {currentPage === 530 && 
          <>
          <div className='text-center'>
          <div className='font-secondary d-inline-block my-3 text-center h6 fw-normal border border-warning p-2'><b>User Journey Map Template Link:</b> : 
          <a className='fs-5 ms-3 text-primary' href='https://docs.google.com/presentation/d/1rkM0uZsCd9TaGy3n8oJBMGmNKeG0abTY3JcQQJ_0Z1M/edit?usp=sharing' target='_blank'>https://docs.google.com/presentation..</a>
          </div>
          </div> 
          </>          
          }          
          {currentPage === 540 && 
          <>
          <div className='text-center'>
          <div className='font-secondary d-inline-block my-3 text-center h6 fw-normal border border-warning p-2'><b>Competitive audit Template Link:</b> : 
          <a className='fs-5 ms-3 text-primary' href='https://docs.google.com/spreadsheets/d/1C08MFV1vN_nqTeHT2jIcvJyho_GY2X3PMknvV7TWkiw/edit?usp=sharing&resourcekey=0-CekCFKky2_riX1a_drXZ0g' target='_blank'>https://docs.google.com/presentation..</a>
          </div>
          </div> 
          </>          
          }          
          {currentPage === 550 && 
          <>
          <div className='text-center'>
          <div className='font-secondary d-inline-block my-3 text-center h6 fw-normal border border-warning p-2'><b>Persona Template Link:</b> : 
          <a className='fs-5 ms-3 text-primary' href='https://docs.google.com/presentation/d/1HPj4E0jyZVbrGQVBtokKFaXSBryQfLpiBf-LbvJ13wg/edit?usp=sharing' target='_blank'>https://docs.google.com/presentation..</a>
          </div>
          </div> 
          </>          
          }
          <br/><br/><br/><br/><br/><br/><br/>
          
      </div>     
      {currentPage === 0 && 
          <>
          
          <div className='text-center img-fluid'><img src='/img/contactform.png' className='img-fluid'/></div>
          
          </>
      }
      {currentPage !== 0 && 
        <>
        <div className='text-center img-fluid bg-white py-5 shadow'><img src='/img/ayata-logo.png' width="300" /></div>
        <div className='text-cetner py-2 bg-theme-secondary text-white'>
          <div className='flex-center justify-content-center container-xl py-2' style={{fontSize:'13px'}}>
          Copyright © 2024 Ayata Commerce. All Rights Reserved. <a className='ms-2 text-white hover-text-theme-orange-light' href='https://www.ayatacommerce.com/' target='_blank'>www.ayatacommerce.com</a>          
            </div>
            </div>
            </>
      }
      {/* <iframe title={`Page ${currentPage}`} src={`page_${Math.floor(currentPage / 10)}_${currentPage % 10}.html`} /> */}
    </div>
  );
};

export default Content;